var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M68.764 25.981c-.692-2.496-2.718-4.466-5.288-5.138-4.696-1.2-23.476-1.2-23.476-1.2s-18.78 0-23.476 1.2c-2.57.672-4.596 2.64-5.288 5.138C10 30.541 10 40.001 10 40.001s0 9.506 1.236 14.02c.692 2.496 2.718 4.464 5.288 5.136 4.696 1.2 23.476 1.2 23.476 1.2s18.78 0 23.476-1.2c2.57-.672 4.596-2.64 5.288-5.138C70 49.459 70 39.999 70 39.999s0-9.458-1.236-14.02zM33.97 48.787V31.311l15.62 8.738z"
  })));
};
export default SvgYoutube;